module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-277.05906b74.jpg";